/* eslint-disable */
import {
  MenuItemsType,
  SwapIcon,
  SwapFillIcon,
  EarnIcon,
  TrophyFillIcon,
  MoreIcon,
} from '@pancakeswap/uikit'
import { ContextApi } from 'contexts/Localization/types'
import { DropdownMenuItems } from '@pancakeswap/uikit/src/components/DropdownMenu/types'
import { DropdownMenuItemType } from '@pancakeswap/uikit/src/components/DropdownMenu/types'

export type ConfigMenuDropDownItemsType = DropdownMenuItems & { hideSubNav?: boolean }
export type ConfigMenuItemsType = Omit<MenuItemsType, 'items'> & { hideSubNav?: boolean } & {
  items?: ConfigMenuDropDownItemsType[]
}

const filterItemBySupportChainId = (item, chainId) => {
  return !chainId || !item.supportChainIds ? true : item.supportChainIds?.includes(chainId)
}

const config: (
  t: ContextApi['t'],
  isDark: boolean,
  languageCode?: string,
  chainId?: number,
) => ConfigMenuItemsType[] = (t, chainId) =>
    [
      {
        label: t('Swap'),
        icon: SwapIcon,
        fillIcon: SwapFillIcon,
        href: '/swap',
        showItemsOnMobile: false,
        items: [],
      },
      {
        label: t('Pools'),
        icon: SwapIcon,
        fillIcon: SwapFillIcon,
        href: '/liquidity',
        showItemsOnMobile: false,
        items: [],
      },
      {
        label: 'Staking',
        href: 'http://24btcc.com/staking',
        icon: EarnIcon,
        type: DropdownMenuItemType.EXTERNAL_LINK,
        items: []
      },
      {
        label: "",
        href: "#",
        icon: MoreIcon,
        items: [
          {
            label: "Marketplace",
            href: "#sec",
            type: DropdownMenuItemType.EXTERNAL_LINK
          },
          {
            label: "NFTs",
            href: "#sec",
            type: DropdownMenuItemType.EXTERNAL_LINK
          },
          {
            label: "Bitcoin Cash",
            href: "http://24btcc.com",
            type: DropdownMenuItemType.EXTERNAL_LINK
          },
          {
            label: "Document",
            href: "http://docs.24btcc.com/",
            type: DropdownMenuItemType.EXTERNAL_LINK
          },
          {
            label: "Chart",
            href: "https://www.dextools.io/app/en/bnb/pair-explorer/0xe7d3b527f3a17973c45fa3b7822e60c73b8f4fcd/",
            type: DropdownMenuItemType.EXTERNAL_LINK
          }
        ]
      }
    ].filter((item) => filterItemBySupportChainId(item, chainId))

export default config